import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/app/[locale]/error.tsx");
